module.exports = __webpack_public_path__ + "c489ee88f2f79ed86c082ac694c08379.MP3";